// extracted by mini-css-extract-plugin
export default {"workOrderDetailsPanel":"WorkOrderDetailsPanel_workOrderDetailsPanel__AVp7t","equipmentDescription":"WorkOrderDetailsPanel_equipmentDescription__baMUu"};